import React from "react";
import styled from "styled-components";

import Checkbox from "../UI/Checkbox";

import baseStyles from "../../styles/baseStyles";

const DropdownCard = styled.ul`
  align-self: flex-start;
  background: ${baseStyles.color.white.o100};
  position: absolute;
  transform: translate(0, 1.5rem);
  list-style: none;
  padding: 1rem;
  box-shadow: ${baseStyles.layers.l5};
  border-radius: 3px;
  visibility: ${props => (props.show ? "visible" : "hidden")};
  opacity: ${props => (props.show ? "1" : "0")};
  z-index: 5;
  transition: 0.2s all ease-in-out;
  cursor: initial;
  ::before {
    content: "";
    position: absolute;
    transform: translate(-50%, -60%);
    top: 50%;
    left: 50%;
    height: 100%;
    width: 100%;
    z-index: -1;
  }
`;

const SelectAll = styled.div`
  border-bottom: 1px solid ${baseStyles.color.white1};
  padding: 0.5rem 0;
  margin-bottom: 0.5rem;
`;

const Dropdown = props => {
  return (
    <DropdownCard {...props}>
      <SelectAll>
        <Checkbox
          label="Select all"
          selected={props.selectedAll}
          onCheckboxChanged={props.onSelectAll}
        />
      </SelectAll>

      {props.options.map(({ label, selected }) => (
        <Checkbox
          key={label}
          label={label}
          selected={selected}
          onCheckboxChanged={labelInput => props.onCheckboxChanged(labelInput)}
        />
      ))}
    </DropdownCard>
  );
};

export default Dropdown;



// WEBPACK FOOTER //
// ./src/components/FilterBar/Dropdown.js